import gql from 'graphql-tag';

export const ContentSchedulePublishQuery = gql`
	query ContentSchedulePublishQuery($contentId: ID!, $status: [String]) {
		content(id: $contentId, status: $status) {
			nodes {
				id
				schedulePublishDate
			}
		}
	}
`;
